import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './ProductsPmsHeader.css';

function ProductsPnHeader() {
    const { t } = useTranslation();

    return (
        <div className='product-header' style={{ backgroundImage: 'url(/images/products-pn-header.png)' }}>
            <div className='page-content d-flex align-items-center'>
                <div className='col-6 d-flex flex-column'>
                    <div className='chip-brown'>

                         {t('Messaging That Works Like Hospitality Should')}
                    </div>
                    <h1>{t('Hotel Guest Messaging & Agent Communication Platform - Prostay Nexus')}</h1>
                    <p className='body-large'>
                        {t('Prostay Nexus is a fully integrated messaging platform that centralizes communication between your reservations team, guests, and agents. From email and WhatsApp to automated confirmations and in-stay requests, Nexus makes it easy to stay connected—professionally, personally, and in real time.')}
                    </p>
                </div>
                <div className='col img-wrapper'>
                    <img src='/images/nexusheader.svg' alt={"Room planning"}/>
                </div>
            </div>
        </div>
    );
}

export default ProductsPnHeader;
